import { gql } from '@apollo/client';
import { BID_BF_PROJECT_FIELDS, BID_BOX_FIELDS, BID_BOX_FULL_FIELDS } from '../queries';
import { UPDATE_TENDER_BOX_FIELDS, LOT_FIELDS } from 'src/models/procurements/queries';
import { INBOX_EMAIL_BASIC_FIELDS } from 'src/models/callOffs/queries';
import { USER_NAME_FIELDS } from 'src/models/users/queries';
import { COMMENT_FIELDS } from '../../comments/queries';

export const BIDS_GENERAL_ITEM_FIELDS = gql`
  fragment bidsGeneralItemFields on General {
    id
    name {
      ...bidBoxFullFields
    }
    buyerBoxes {
      ...bidBoxFullFields
    }
    contractValueBoxes {
      ...bidBoxFullFields
    }
    description {
      ...bidBoxFullFields
    }
    contractDurationBoxes {
      ...bidBoxFullFields
    }
    locationBoxes {
      ...bidBoxFullFields
    }
    placeOfPerformanceNutsCode {
      ...bidBoxFullFields
    }
    linkToProcurerBoxes {
      ...bidBoxFullFields
    }
    contractRenewalBoxes {
      ...bidBoxFullFields
    }
    typeOfProcedureBoxes {
      ...bidBoxFullFields
    }
  }
  ${BID_BOX_FULL_FIELDS}
`;

export const BIDS_TIMELINE_ITEM_FIELDS = gql`
  fragment bidsTimelineItemFields on TimelineRefactored {
    id
    availableDate {
      ...bidBoxFullFields
    }
    contractStartAndEndStart {
      ...bidBoxFullFields
    }
    deadlineOfClarificationQuestions {
      ...bidBoxFullFields
    }
    deadline {
      ...bidBoxFullFields
    }
  }
  ${BID_BOX_FULL_FIELDS}
`;

export const BIDS_FIELDS_PREVIEW = gql`
  fragment bidsFieldsPreview on BidV2 {
    id
    bidStageId
    createdAt
    createdBy {
      ...userNameFields
    }
    comments {
      ...commentFields
    }
    status {
      id
      name
    }
    assignedTo {
      ...userNameFields
    }
    workspace {
      id
      name
      color
    }
    isRejected
    itemType
    itemId
    ...BidByggfaktaProjectFields
    mails {
      ...inboxEmailBasicFields
    }
    item {
      ... on Tender {
        id
        procurementStatus
        assignedTo {
          ...userNameFields
        }
        timeline {
          ...bidsTimelineItemFields
        }
        general {
          ...bidsGeneralItemFields
        }
        lots {
          ...lotFields
        }
        isFilledData
        isInProgress
        custom {
          ...bidBoxFields
        }
      }
      ... on UserMail {
        ...inboxEmailBasicFields
        timeline {
          ...bidsTimelineItemFields
        }
        general {
          ...bidsGeneralItemFields
        }
        custom {
          ...bidBoxFields
        }
      }
      ... on ManualBidItem {
        id
        timeline {
          ...bidsTimelineItemFields
        }
        general {
          ...bidsGeneralItemFields
        }
        custom {
          ...bidBoxFields
        }
      }
    }
  }
  ${USER_NAME_FIELDS}
  ${BIDS_GENERAL_ITEM_FIELDS}
  ${BIDS_TIMELINE_ITEM_FIELDS}
  ${BID_BOX_FIELDS}
  ${COMMENT_FIELDS}
  ${INBOX_EMAIL_BASIC_FIELDS}
  ${LOT_FIELDS}
  ${BID_BF_PROJECT_FIELDS}
`;

export const GET_BID_PREVIEW = gql`
  query getPreviewBid($bidId: String!) {
    getBidV2(input: { bidId: $bidId }) {
      ...bidsFieldsPreview
    }
  }
  ${BIDS_FIELDS_PREVIEW}
`;

export const UPDATE_TENDER_BOX = gql`
  mutation updateTenderBox($id: String!, $bidId: String!, $box: TenderBoxInput!) {
    updateTenderBox(input: { id: $id, bidId: $bidId, box: $box }) {
      id
      specificationId
      category
      ...boxFieldsFieldResult
    }
  }
  ${UPDATE_TENDER_BOX_FIELDS}
`;

export const UPDATE_CUSTOM_TENDER_BOX = gql`
  mutation updateCustomBidFieldBox($id: String!, $bidId: String!, $box: CustomBidFieldBoxInput!) {
    updateCustomBidFieldBox(input: { id: $id, bidId: $bidId, box: $box }) {
      id
      specificationId
      ...boxFieldsFieldResult
    }
  }
  ${UPDATE_TENDER_BOX_FIELDS}
`;

export const REJECT_BID = gql`
  mutation rejectBid($id: String!, $rejected: Boolean!) {
    rejectBid(input: { id: $id, rejected: $rejected }) {
      id
      isRejected
    }
  }
`;
